import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M2 14v-4a2 2 0 0 1 2-2h2.172a2 2 0 0 0 1.414-.586l2.853-2.853C11.384 3.616 13 4.285 13 5.62v12.76c0 1.336-1.616 2.005-2.56 1.06l-2.854-2.853A2 2 0 0 0 6.172 16H4a2 2 0 0 1-2-2"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.828 7.757a1 1 0 0 1 1.415 0 6 6 0 0 1 0 8.486 1 1 0 1 1-1.415-1.414 4 4 0 0 0 0-5.657 1 1 0 0 1 0-1.415",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.657 4.929a1 1 0 0 1 1.414 0 10 10 0 0 1 0 14.142 1 1 0 0 1-1.414-1.414 8 8 0 0 0 0-11.314 1 1 0 0 1 0-1.414",
      clipRule: "evenodd"
    }
  )
);
var SvgSoundHighFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SoundHighFilled_default = SvgSoundHighFilled;

export { SoundHighFilled_default as default };
